import React from 'react';
import { PDFIcon } from '../../../../components/Icon/Icon';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>
        <h2>Sustainability – The Story so Far</h2>
        Sustainability is and will continue to be an area of significant focus throughout the JD
        Group for 2020 and beyond, not least in our Own Brand product range, consumables and energy
        usage. To find out more about our “Sustainability” ethos and future ambitions, please read
        the JD Group Sustainability Statement below:
        <ul className="column">
            <li>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://files.jdplc.com/pdf/reports/jd-sustainability-statement-november-2020.pdf"
                    title="Sustainability Statement"
                >
                    <PDFIcon name="sustainability/sustainability-statement-1.png" />
                    Sustainability Statement November 2020
                </a>
            </li>
        </ul>
        <h2>Plastic</h2>
        <h2 className="underline">Plastic vs. Paper – The debate</h2>
        <br />
        When identifying opportunities to reduce plastic useage, it is important to carefully review
        the impact of alternative materials. Many alternatives to plastic do not achieve the desired
        environmental benefits (i.e. they may have a higher carbon footprint, or have a detrimental
        environmental impact if not disposed of correctly).
        <br />
        <br />
        Changes to materials need to consider function, purpose and full-life environmental impact.
        The greatest mitigation of negative impacts on the environment is reuse. Plastic bags reused
        just 3-4 times are more environmentally friendly than a single use paper bag.
        <br />
        <br />
        Suppliers with ideas or innovations that would help to reduce our environmental impact are
        welcome to contact our Energy and Environment team via{' '}
        <a className="link" href="mailto:newsupplierenquiries@jdplc.com">
            newsupplierenquiries@jdplc.com
        </a>
        .<br />
        <br />
        More information on the plastic debate and our journey within it, can be found via the case
        study below:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/Plastic-vs-Paper-The-Facts.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Plastic Useage Case Study"
                >
                    <PDFIcon name="sustainability/plastic-usage-1.png" />
                    Plastic Usage Case Study
                </a>
            </li>
        </ul>
        <h2 className="underline">How we mitigate the impact of using plastic</h2>
        <ul className="list">
            <li>
                Reuse
                <br />
                We created a quality plastic drawstring bag for our consumers which, with an over
                the shoulder cord, is designed perfectly to carry anything from P.E. kits, to a
                change of clothes, to shopping. The JD bag is so popular that it is widely resold on
                eBay! Our JD drawstring bag is classified as a ‘bag for life’, but we still apply
                the carrier bag levy fee to this bag, with all proceeds going to{' '}
                <a className="link" href="/jd-foundation">
                    The JD Foundation
                </a>
                .
            </li>
            <li>
                Reduce
                <br />
                We have created a “junior” sized JD drawstring bag for smaller items, using 39% less
                plastic than the “adult” size equivalent.
            </li>
        </ul>
        <br />
        In 2019, we have increased our standard and junior drawstring bags from 33% to 50% recycled
        material, with the first new specification bags arriving in store in late 2018. Our US and
        Australian businesses work with in-country suppliers to minimise carbon usage arising from
        transportation, and will be aiming to increase from 33% to 50% recycled material by the end
        of Jan 2021.
        <br />
        <br />
        More information on how we try to encourage reuse and reduce the amount of plastic can be
        found in our{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-and-accounts-2020.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>{' '}
        and the Case Study below:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/Reducing-Plastic-Consumables.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Reducing Plastic Case Study"
                >
                    <PDFIcon name="sustainability/reducing-plastic.png" />
                    Reducing Plastic Case Study
                </a>
            </li>
        </ul>
        <h2>Textiles</h2>
        Approximately 90% of the Group’s sales come from products supplied by third party brands.
        The Group’s two principal brands are Nike and adidas who are recognised as industry leaders
        with regards to driving sustainability within the design and development of their product
        ranges. The balance of the Group’s sales relates to private label products and there is an
        ongoing project, led at a senior level, to review options on improving the sustainability of
        our manufactured garments. The Group have considered several initiatives and are proud to
        become a member of{' '}
        <a
            className="link"
            href="https://wrap.org.uk/taking-action/textiles/initiatives/textiles-2030"
            target="_blank"
            rel="noopener noreferrer"
            title="Textiles 2030"
        >
            Textiles 2030
        </a>
        . Textiles 2030 is part of a world-wide initiative, led by WRAP, to reduce the environmental
        impact of clothing across the globe.
        <br />
        <br />
        Having previously harvested data from our Mills and Dye houses and visiting selected sites
        to evaluate their ZDHC compliance (Zero Discharge of Hazardous Chemicals), we are moving
        into our next phase by engaging with a 3rd party to develop an initial self-assessment tool
        for management of sustainability and environmental issues in our supply chain. This will
        work towards the goals set within the Textiles 2030 initiative.
        <br />
        <br />
        As with many fashion retailers, planning is key to sustainability and the reduction of
        airfreight of product was a focus for JD Sports. With better sourcing, planning and
        forecasting across departments we have been able to reduce dramatically our intake of
        airfreighted product which means our carbon emissions have reduced by 4,341t CO2e.
        <br />
        <br />
        <h2>Sustainability in Private Label Manufacturing</h2>We started our journey towards
        responsible sourcing in June 2019 and, between then and now, have been working to make
        sustainability an integral part of our private label production from conception, to the end
        product and beyond.
        <h4>
            <i>The JD Group are proud members of the Better Cotton Initiative (BCI)</i>
        </h4>
        We are committed to increasing the amount of Better Cotton in our private label
        manufacturing with a target of sourcing 80% of our cotton as “Better Cotton” by 2022.
        <br />
        <br />
        Better Cotton is not physically traceable to end products. However, BCI Farmers benefit from
        the demand for Better Cotton in equivalent volumes to those we source.
        <br />
        <br />
        To find out more on how JD is working with the BCI to mitigate our impact on the environment
        and help local communities, please read the case study below:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/Better-Cotton-Initiative.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Better Cotton Initiative Case Study"
                >
                    <PDFIcon name="sustainability/better-cotton.png" />
                    Better Cotton Initiative Case Study
                </a>
            </li>
        </ul>
        We will track our progress against our targets internally through a “medal” based system
        whereby different “medals” will be awarded to our own brands depending on their level of
        sustainability. This will help us measure, monitor and improve sustainability across our
        ranges. This medal system is displayed below.
        <br />
        <br />
        <img
            className="full"
            alt="JD own label sustainability award. Brand achievement goals"
            title="JD own label sustainability award"
            src="https://files.jdplc.com/images/about/jd-sustainability-award.jpg"
        />
        <h4>
            <i>Sustainable Processes</i>
        </h4>
        Our private label design and development teams actively promote and encourage sustainable
        practices in every stage of the supply chain from initial concept to final production.
        Conscious led designing, the increased use of sustainable materials and incorporating
        sustainable manufacturing processes into the production will assist us to achieve our goals.
        Examples of sustainable manufacturing processes within our Tier 2 partners include:
        <h4>Water</h4>
        <ul className="list">
            <li>
                Garments manufactured using water saving processes and technologies reducing water
                consumption including the recycling of waste water.
            </li>
        </ul>
        <h4>Energy</h4>
        <ul className="list">
            <li>
                Encouraging partners in our supply chain to use renewable energy sources such as
                Solar or Wind and efficient manufacturing technology.
            </li>
        </ul>
        <h4>Carbon</h4>
        <ul className="list">
            <li>
                Reducing the impact of GHG using technologies to reduce the CO<sup>2</sup> footprint
                of the manufacturing process.
            </li>
        </ul>
        <br />A good example of how making a small change within our processes can make a big
        difference in sustainability is our case study on Micro-Pak® Dri Clay v.s. Silica Gel
        sachets. By replacing 3.3 million silica gel sachets with micro-pak® dri clay in the
        packaging of our Own Brand products, we managed to substantially reduce our water and
        chemical usage and plastic and waste to landfill. More information is in our caste study
        below:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/micro-pak-vs-silica-gel.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Micro-Pak® Dri Clay v.s. Silica Gel sachets case study"
                >
                    <PDFIcon name="sustainability/office-recycling-case-study-1.png" />
                    Micro-Pak® Dri Clay v.s. Silica Gel sachets case study
                </a>
            </li>
        </ul>
        <h4>
            <i>Product Manufacturing Process</i>
        </h4>
        At this present time, sustainability is not cost neutral. One of the reasons for this is
        availability of supply and demand so considerations must be made from the very start. These
        are Availability, Affordability, Aesthetics and Performance. It may not always be possible
        for commercial reasons on some brands that we produce in house to include sustainable
        fabrics, but it is important to consider all opportunities no matter how small or
        insignificant they can appear.
        <br />
        <br />
        Considerations are to be given to:
        <br />
        <ul className="list">
            <li>All products</li>
            <li>Recycled Care labels</li>
            <li>FSC Barcode stickers with APEO free adhesive</li>
            <li>Recycled Hangtags/Strings</li>
        </ul>
        More information on sustainability within our own private label can be found within the{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-and-accounts-2020.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>{' '}
        and to find out more about how we mapped and investigated this process, please access the
        case studies below:
        <br />
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/Sustainability-Key-Facts.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Sustainability and the Facts"
                >
                    <PDFIcon name="sustainability/office-recycling-case-study-2.png" />
                    Sustainability and the Facts
                </a>
            </li>
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/sustainable-product-mapping.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Sustainable Product Mapping"
                >
                    <PDFIcon name="sustainability/product-mapping-1.png" />
                    Sustainable Product Mapping
                </a>
            </li>
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/sustainable-design-process-map.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Sustainable Design Process"
                >
                    <PDFIcon name="sustainability/sustainable-design.png" />
                    Sustainable Design Process
                </a>
            </li>
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/recycled-costing-jacket.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Recycled Costing Jacket (December 2018)"
                >
                    <PDFIcon name="sustainability/recycled-jacket.png" />
                    Recycled Costing Jacket (December 2018)
                </a>
            </li>
        </ul>
        Our “Own Brand Production Pyramid” illustrates the conversion of the components used in the
        manufacture of the product to sustainable materials and manufacturing processes by
        percentage across the own label ranges. The pyramid also includes the sustainable percentage
        of styles by brand, by volume.
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/jd-own-brand-production-pyramid.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Own Brand Production Pyramid"
                >
                    <PDFIcon name="sustainability/own-brand-pyramid.png" />
                    Own Brand Production Pyramid
                </a>
            </li>
        </ul>
        <h4>
            <i>Customer Education</i>
        </h4>
        In terms of the long-term Sustainability strategy, we believe more onus should be put on the
        consumer to help recycle used products and therefore, we think the education piece is
        critical to this. With this in mind, we plan to increase the promotion of educational tools
        like the one below:
        <br />
        <br />
        <img
            className="full"
            src="https://files.jdplc.com/images/jd-reuse-repair-recycle.jpg"
            alt=""
        />
        <h2>Recycling and Waste Management</h2>
        <h2 className="underline">Increasing Recycled Content (online packaging):</h2>
        <br />
        We completed a material specification and commercial review for our core UK distribution
        sites for our online packaging. As a result, we now use 100% recycled material for our
        online packaging. By choosing to use recycled plastic material (avoiding virgin material),
        the 2019/20 equivalent embodied carbon saving was 339t co2e*. The equivalent co2 saved is
        2,950,435 km travelled by plane, or 73 flights around the world. New messaging has also been
        introduced to provide further guidance to our customers of how they can dispose these
        materials.
        <br />
        <br />
        For more information on how we increased recycled content please read our{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-and-accounts-2020.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>{' '}
        and the case study below:
        <br />
        <br />
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/online-packaging.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Increasing recycled content (Online packaging)"
                >
                    <PDFIcon name="sustainability/increasing-recyled-content-online-packaging.png" />
                    Increasing recycled content (Online packaging)
                </a>
            </li>
        </ul>
        <h2 className="underline">Office Recycling and Waste Management</h2>
        <br />
        Wherever possible, plastic or cardboard, is removed at the earliest source of our core
        supply chain (our Kingsway DC). During the year, the amount of cardboard recycled increased
        to 5,491 tonnes (2018: 4,756 tonnes).
        <br />
        <br />
        In 2019, we outsourced our waste management on-site to a third-party supplier, this has
        enabled the Group to trial new initiatives such as re-processing used hangers back into our
        estate via backhauling and reducing our general waste streams through finding different
        solutions for these materials. We achieved ‘zero waste to landfill’ accreditation in
        February 2020 after an third-party audit of our Kingsway DC waste and recycling processes.
        <br />
        <br />
        We continue to expand our use of the Dry Mixed Recycling (‘DMR’) schemes to all of our
        stores and businesses in the UK and Ireland, to maximise waste diversion from landfill. In
        2019, we diverted 99% (2018: 98%) from landfill of our waste.
        <br />
        <br />
        For more information regarding waste management, please read our{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-and-accounts-2020.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>{' '}
        or the case study below:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/Office-Recyling.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Office Recycling Case Study"
                >
                    <PDFIcon name="sustainability/office-recycling-case-study.png" />
                    Office Recycling Case Study
                </a>
            </li>
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/zero-to-landfill.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Zero to Landfill: Kingsway Distribution Centre"
                >
                    <PDFIcon name="sustainability/zero-landfill.png" />
                    'Zero to Landfill’: Kingsway Distribution Centre
                </a>
            </li>
        </ul>
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/sustainability.jpg',
    body: Body,
};
